const PrfActivities = () => {
  mapboxgl.accessToken =
    'pk.eyJ1IjoiY2Nid3Fwb3J0YWwiLCJhIjoiY2plcmdqcnB2MDYzbTM0dW13aWp6cXhnbiJ9.wnHy3esIvSyv_MdNX_nwqw';

  const map = new mapboxgl.Map({
    container: 'prf-activities-map',
    style: 'mapbox://styles/ccbwqportal/cjrqnxsjz0fhh2snqq1j8wdyz',
    zoom: 10,
    center: [-104.854032, 39.569983],
  });

  // Control implemented as ES6 class
  class LegendControl {
    onAdd(map) {
      this._map = map;
      this._container = document.createElement('div');
      this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
      this._container.innerHTML = `
          <ul class="prf-map-legend">
            <li>
              <span class="prf-map-legend-point"></span>
              <span>PRF Facility</span>
            </li>
            <li>
              <span class="prf-map-legend-polygon"></span>
              <span>PRF Boundaries</span>
            </li>
            <li>
              <span class="prf-map-legend-line"></span>
              <span>PRF Reach</span>
            </li>
            <li>
              <span class="prf-map-legend-destrat"></span>
              <span>Destratification System</span>
            </li>
          </ul>
        `;
      return this._container;
    }

    onRemove() {
      this._container.parentNode.removeChild(this._container);
      this._map = undefined;
    }
  }

  // Add Mapbox navigation control to map
  const nav = new mapboxgl.NavigationControl();
  map.addControl(nav, 'top-left');

  map.addControl(new LegendControl(), 'bottom-right');

  // Create a popup, but don't add it to the map yet.
  const popup = new mapboxgl.Popup({
    closeButton: true,
    closeOnClick: true,
  });

  /**
   * Utility function used to create Mapbox popup
   * @param {object} e JavaScript event object
   */
  function createPopup(e) {
    // Change the cursor style as a UI indicator.
    map.getCanvas().style.cursor = 'pointer';

    const feature = e.features[0].properties;
    console.log(feature);
    const coords = [e.lngLat.lng, e.lngLat.lat];

    // Populate the popup and set its coordinates
    // based on the feature found.
    popup.setLngLat(coords).setHTML(feature.Name).addTo(map);
  }

  // Create popup on hover for the following three layers
  map.on('mouseover', 'prf-points', createPopup);
  map.on('mouseover', 'prf-lines', createPopup);
  map.on('mouseover', 'prf-polygons', createPopup);

  let DummySliderData = {};
  for (let i = 1991; i < 2022; i++) {
    DummySliderData[i] = i;
  }

  const prfYearSliderValue = document.querySelector('#prf-construction-year-value');
  const prfYearSlider = new Slider({
    container: '#prf-construction-year',
    elementExists: true,
    valueField: 'val',
    displayField: 'display',
    objectData: DummySliderData,
    displayValue: false,
    onChange: () => {
      const val = +prfYearSlider.val();
      prfYearSliderValue.textContent = val;

      map.setFilter('prf-points', ['<=', 'year', val]);
      map.setFilter('prf-points-8wd572', ['<=', 'year', val]);
      map.setFilter('prf-lines', ['<=', 'year', val]);
      map.setFilter('prf-lines-0blpd8', ['<=', 'year', val]);
      map.setFilter('prf-polygons', ['<=', 'year', val]);
      map.setFilter('prf-polygons-31r9yj', ['<=', 'year', val]);
      map.setFilter('prf-destrat', ['<=', 'year', val]);
      map.setFilter('destrat-sys-9dmwyf', ['<=', 'year', val]);
    },
  });
  prfYearSlider.val(2021);

  /**
   * Create a class for the PRF Sites List
   * This makes it easier to manage the site list and associated
   * functionality such as hide/show and populating the list
   */
  class PrfList {
    constructor() {
      this.container = document.querySelector('#prf-site-list');
      this.visible = false;
      this.interval;
      this.timeLapseRunning = false;
      this.data = [
        {
          name: '1 - Destratification System',
        },

        {
          name: '4 - West Boat Ramp Parking Lot',
        },
        {
          name: '5 - East Boat Ramp Shoreline Stabilization',
        },
        {
          name: '6 - Dixon Grove Shoreline Stabilization',
        },
        {
          name: '7 - East Shade Shelter',
        },
        {
          name: '8 - Tower Loop Shoreline Stabilization',
        },
        {
          name: '9 - East Shade Shelter Ph II',
        },
        {
          name: '10 - East Boat Ramp Ph II',
        },
        {
          name: '11 - Rueter Hess Diversion',
        },
        {
          name: '12 - Cherry Creek at Eco Park',
        },
        {
          name: '13 - Cherry Creek at PJCOS',
        },
        {
          name: '14 - Cottonwood Creek at Easter Avenue',
        },
        {
          name: '15 - Cottonwood Stream Reclamation Ph I and II',
        },
        {
          name: '16 - McMurdo Gulch',
        },
        {
          name: '17 - Quincy Drain',
        },
        {
          name: '18 - Shop Creek Wetlands',
        },
        {
          name: '19 - Cherry Creek at 12-Mile Park-Ph I',
        },
        {
          name: '20 - WBR-Storm',
        },
        {
          name: '21 - Mountain and Lake Loop Shoreline Stabilization',
        },
        {
          name: '22 - Cherry Creek at Norton Open Space/Farms',
        },
        {
          name: '23 - Cherry Creek CCSP to EcoPark',
        },
        {
          name: '25 - McCabe Meadows Trailhead',
        },
        // {
        //   name: '26 - Cherry Creek d/s Piney Creek',
        // },
        {
          name: '27 - Cherry Creek at 12-Mile Park Ph II',
        },
        {
          name: '28 - Bowtie Project',
        },
        {
          name: '29 - Cherry Creek at Lincoln Ave',
        },
        {
          name: '30 - Cherry Creek at Main Street',
        },
        {
          name: '31 - Hess Rd. Extension Proj.',
        },

        {
          name: '33 - Cherry Creek at Pine Lane',
        },
        {
          name: '34 - Piney Creek Stream Reclamation',
        },

        {
          name: '36 - Cherry Creek at Stroh Road',
        },
        {
          name: '37 - Cherry Creek Open Space',
        },
        {
          name: '38 - Trib B Airport EDB East',
        },
        {
          name: '39 - Trib B Airport EDB West',
        },
        {
          name: '40 - Cottonwood Wetlands',
        },
        {
          name: '41 - Cottonwood Creek Peoria Pond',
        },
        {
          name: '42 - WBR Pond',
        },
        {
          name: '43 - Piney Creek Reach 6',
        },
        {
          name: '44 - Piney Creek Reach 7',
        },
        {
          name: '45 - Peoria Pond Interpretive Sign Replacement',
        },
        {
          name: '46 - Cherry Creek Upstream of Scott Road',
        },
        {
          name: '47 - Cherry Creek State Park Meterological Station',
        },
      ];
      this.init();
    }

    // bind all events on the class
    bindEvents() {
      const { container } = this;
      const toggleBtn = container.querySelector('#prf-list-btn');
      toggleBtn.addEventListener('click', this.toggleDisplay.bind(this));
    }

    runTimeLapse(year) {
      map.setFilter('prf-points', ['<=', 'year', year]);
      map.setFilter('prf-lines', ['<=', 'year', year]);
      map.setFilter('prf-polygons', ['<=', 'year', year]);
      map.setFilter('prf-destrat', ['<=', 'year', year]);
    }

    toggleTimeLapse() {
      const timeLapseBtn = this.container.querySelector('#prf-time-lapse');
      this.timeLapseRunning = !this.timeLapseRunning;
      let year = 1995;
      if (this.timeLapseRunning) {
        timeLapseBtn.textContent = 'Stop Time Lapse';
        map.setFilter('prf-points', ['==', 'year', 1901]);
        map.setFilter('prf-points-8wd572', ['==', 'year', 1901]);
        map.setFilter('prf-lines', ['==', 'year', 1901]);
        map.setFilter('prf-lines-0blpd8', ['==', 'year', 1901]);
        map.setFilter('prf-polygons', ['==', 'year', 1901]);
        map.setFilter('prf-polygons-31r9yj', ['==', 'year', 1901]);
        map.setFilter('prf-destrat', ['==', 'year', 1901]);
        map.setFilter('destrat-sys-9dmwyf', ['==', 'year', 1901]);
        this.interval = setInterval(() => {
          this.runTimeLapse(year);
          year = year + 1;

          if (year > 2021) {
            clearInterval(this.interval);
            this.timeLapseRunning = false;
          }
        }, 1000);
      } else {
        clearInterval(this.interval);
        timeLapseBtn.textContent = 'Start Time Lapse';
        map.setFilter('prf-points', null);
        map.setFilter('prf-points-8wd572', null);
        map.setFilter('prf-lines', null);
        map.setFilter('prf-lines-0blpd8', null);
        map.setFilter('prf-polygons', null);
        map.setFilter('prf-polygons-31r9yj', null);
        map.setFilter('prf-destrat', null);
        map.setFilter('destrat-sys-9dmwyf', null);
      }
    }

    /**
     * Utility method used to show/hide the PRF list
     */
    toggleDisplay() {
      const { container } = this;
      const btn = container.querySelector('.btn');
      const list = container.querySelector('.prf-list');
      const classList = list.classList;
      if (classList.contains('hidden')) {
        list.classList.remove('hidden');
        btn.textContent = 'Hide Sites';
      } else {
        list.classList.add('hidden');
        btn.textContent = 'Show Sites';
      }
      return this;
    }

    /**
     * Utility method used to build the PRF Site List using the provided data
     */
    build() {
      const { container, data } = this;
      const list = document.createElement('ul');
      list.classList += 'prf-list hidden';
      const lis = data.map(d => {
        const li = document.createElement('li');
        li.textContent = d.name;
        list.appendChild(li);
      });
      container.appendChild(list);
      return this;
    }

    /**
     * Utility method for running required functionality on class initialization
     */
    init() {
      this.bindEvents();
      this.build();
      return this;
    }
  }

  // Initialize the PRF Site List
  const prfList = new PrfList();
};
